import { useCallback, useEffect, useState } from "react";
import { Button, TextField } from "@mui/material";
import { CommonModalWrap, OneList } from "../../styles/common";
import styled from "styled-components";
import theme from "../../styles/theme";
import CommonModalBar from "../common/CommonModalBar";
import { useQueryClient } from "react-query";
import { useSetCars } from "../../interfaces/carsClass";
import { MODAL_QUERY_NM } from "../../interfaces/modal";


const CarsDetail = ({mode, ccid, cars}) => {

    const [popOpen, setPopOpen] = useState(false);
    const [target, setTarget] = useState();

    const handlePopClose = () => {
        setTarget();
        setPopOpen(false);
    }

    return (
        <div style={{height: 'inherit',display:'flex',flexDirection:'column'}}>
            <OneList>
                <ul className="descArea">
                    {cars && cars.map((item,index)=>{
                        return(
                            <li key={index} className={'descLiItem '+((target && target.cno===item.cno) ? 'selected':'')} onClick={()=>setTarget(item)}>
                                <span>{item.car_idx}</span>
                                <span>{item.car_tm}</span>
                            </li>
                        )
                    })}
                </ul>
            </OneList>
            {mode !== 'VIEW' &&
            <div style={{display:'flex',gap:'0.25rem',justifyContent:'space-between',alignItems:'center'}}>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>{setTarget();setPopOpen(true)}}>추가</Button>
                <Button variant="contained" style={{width:'100%'}} onClick={()=>setPopOpen(true)}>수정</Button>
            </div>
            }
            {popOpen && <CarsPop ccid={ccid} target={target} close={handlePopClose} />}
        </div>
    )

}

const DetailWindow = styled.div`
    position: relative;
    background: ${theme.color.white[100]};
    width: 50%;
    height: 16rem;
    border-radius: 18px;
    padding: 1rem 1rem;
`;

const MainBody = styled.div`
    padding: 1.5rem 0rem 1.5rem 0rem;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    gap: 1rem;
    overflow:auto;
    height: calc(16rem - 2rem - 40px);

    .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 8px;
    }
`;

const ButtonBox = styled.div`
    display: flex;
    justify-content: flex-end;
    height: 40px;
    gap: 8px;
`;

const CarsPop = ({ccid, target, close}) => {

    const queryClient = useQueryClient();

    const [cars, setCars] = useState();

    const { mutate } = useSetCars();

    useEffect(()=>{
        setCars(target);
    },[target])

    const handleSubsClick = useCallback((updateItem) => {
        const temp = {
            mode: updateItem.cno>0 ? 'PUT':'POST',
            ...updateItem,
            ccid: ccid
        }
        mutate(
            temp,
            {
                onSuccess:(res)=>{
                    queryClient.setQueryData(
                        [MODAL_QUERY_NM],
                        {
                            show:true,
                            msg:(updateItem.cno>0 ? '수정':'등록')+'하였습니다.',
                            height:'20vh',
                        }
                    )
                    close();
                }
            }
            )
    })

    const handleValueChange = (id, val) => {
        const temp  = {...cars,[id]:val}
        setCars(temp);
    }

    const handleCloseClick = () => {
        close(false);
    }

    return (
        <CommonModalWrap style={{zIndex:1300}}>
            <DetailWindow>
                <CommonModalBar title={(target) ? '차종 정보' : '차종 등록'} close={handleCloseClick}/>
                <MainBody>
                    <div className="row" >
                            {(target && target.cno && target.cno > 0) &&
                                <TextField 
                                id='car_idx' 
                                label='차종순번' 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={cars ? cars.car_idx : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            }
                            <TextField 
                                id='car_tm' 
                                label='표기 차종명' 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={cars ? cars.car_tm : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                            <TextField 
                                id='car_nm' 
                                label='차종명' 
                                size='small' 
                                InputLabelProps={{shrink:true}} 
                                value={cars ? cars.car_nm : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </div>
                        <div className="row" >
                            <TextField 
                                id='descr' 
                                label='설명' 
                                size='small' 
                                fullWidth
                                InputLabelProps={{shrink:true}} 
                                value={cars ? cars.descr : ''}
                                onChange={(e)=>handleValueChange(e.target.id,e.target.value)}
                            />
                        </div>
                        <ButtonBox>
                            <Button variant="contained" onClick={()=>handleSubsClick(cars)}>등록</Button>
                        </ButtonBox>
                </MainBody>
            </DetailWindow>
        </CommonModalWrap>
    )
}


export default CarsDetail;
